module.exports = __webpack_public_path__ + "static/media/icon_seat_2.e7d9389f.png";